import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiFetch } from 'api/client';

type UrlOrBuilder<TVars> = string | ((vars: TVars) => string);

export const useApiMutation = <TData, TVariables = void, TContext = unknown>(
  url: UrlOrBuilder<TVariables>,
  method: 'POST' | 'PUT' | 'PATCH' | 'DELETE',
  options?: UseMutationOptions<TData, Error, TVariables, TContext>
) => {
  return useMutation<TData, Error, TVariables, TContext>({
    mutationKey: ['mut', method, typeof url === 'string' ? url : 'fn'],
    mutationFn: async (variables: TVariables) => {
      const finalUrl = typeof url === 'function' ? url(variables) : url;

      const body =
        typeof FormData !== 'undefined' && (variables as any) instanceof FormData
          ? (variables as any)
          : (variables as any);

      return apiFetch<TData>(finalUrl, { method, body });
    },
    ...options
  });
};